import { ONBOARDING } from 'constants/Paths';
import useInactiveCustomerLock from 'hooks/useInactiveCustomerLock';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { isPathAllowedForLockedCustomer } from 'utils/InactiveCustomerUtils';

/**
 * Client-side fallback of the SSR redirect in doWithServerSide (BV-1886): keeps a locked
 * inactive customer on /onboarding for pages served from cache, pages that do not go
 * through doWithServerSide, and right after logging in.
 */
const InactiveCustomerGuard = () => {
  const router = useRouter();
  const isLocked = useInactiveCustomerLock();

  useEffect(() => {
    if (!isLocked || isPathAllowedForLockedCustomer(router.pathname)) return;
    router.replace(ONBOARDING);
  }, [isLocked, router.pathname]);

  return null;
};

export default InactiveCustomerGuard;
